// extracted by mini-css-extract-plugin
module.exports = {"emailSideTab":"az_H3","expanded":"az_I3","disappear":"az_J3"};